// https://app.growthbook.io/features/mccerts-280_v2
// Note: This file remains in the 'mccerts-280_v1' directory for legacy reasons,
// but the experiment flag value has been updated to 'mccerts-280_v2'.
export const MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG = 'mccerts-280_v2'
